module.exports = __webpack_public_path__ + "img/img.6b7dd4b8.jpg";